import { IUser } from 'api-paths-cas';
import { WarningTypeEnum } from '..';
import { ActionSelection } from '../../../types';

export const handleResendResetAction = (
  action: ActionSelection,
  studentUserRecord: IUser | null,
  resendStudentInvite: (uniId: string, username: string, pathway?: string) => void,
  resetStudentPassword: (uniId: string, username: string, pathway?: string) => void,
  showResendResetPasswordWarning: (
    warningType: WarningTypeEnum,
    studentUserRecord: IUser | null,
    { action }: { action: () => void },
  ) => void,
) => {
  const handleAction = () => {
    if (!studentUserRecord) {
      return false;
    }

    const uniId = studentUserRecord?.university ?? '';
    const username = studentUserRecord?.s_key ?? '';
    const pathway = studentUserRecord?.pathway ?? '';

    if (action === ActionSelection.RESET_PASSWORD) {
      return resetStudentPassword(uniId, username, pathway);
    }
    return resendStudentInvite(uniId, username, pathway);
  };

  const isResetPassword = action === ActionSelection.RESET_PASSWORD;

  showResendResetPasswordWarning(
    isResetPassword ? WarningTypeEnum.RESET_PASSWORD : WarningTypeEnum.RESEND_INVITATION,
    studentUserRecord,
    {
      action: () => {
        handleAction();
      },
    },
  );
};
